export async function getTerm(request, ident) {
    const term = await request({
        url: "/terms/" + ident,
        method: "get"
      });
    return term;
}

export async function agreeTerm(request, ident) {
    const term = await request({
        method: "post",
        url: "/terms/" + ident,
      });
    return term;
}
